import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../components/Loading";
import { setAppToken } from "../store/slices/appAuthSlice";
import { exitSandbox, mintSandboxSession } from "../lib/sandbox";

/**
 * Public entry point for the read-only sandbox, linked from the commercial
 * website (https://app.insaion.com/sandbox). Mints an anonymous demo session
 * and drops the visitor straight into the app — no registration, no Zitadel.
 */
export default function SandboxPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = await mintSandboxSession();
        if (cancelled) return;
        dispatch(setAppToken(token));
        navigate("/monitoring", { replace: true });
      } catch {
        if (!cancelled) {
          exitSandbox();
          setFailed(true);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [dispatch, navigate]);

  if (failed) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-4 text-neutral-200">
        <h1 className="text-xl font-semibold">
          The sandbox is not available right now
        </h1>
        <p className="text-sm text-neutral-400">
          Please try again in a moment, or create a free account instead.
        </p>
        <div className="flex gap-3">
          <Link
            to="/register"
            className="rounded-md bg-sky-600 px-4 py-2 text-sm font-medium text-white hover:bg-sky-500"
          >
            Create free account
          </Link>
          <a
            href="https://insaion.com"
            className="rounded-md border border-neutral-600 px-4 py-2 text-sm font-medium text-neutral-300 hover:bg-neutral-800"
          >
            Back to insaion.com
          </a>
        </div>
      </div>
    );
  }

  return <Loading />;
}
